package com.anjuros.website.redesign.components

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.redesign.styles.RdIconCircleStyle
import com.anjuros.website.redesign.styles.RdIncludedGridStyle
import com.anjuros.website.redesign.styles.RdIncludedListStyle
import com.anjuros.website.redesign.styles.RdInlineLinkStyle
import com.anjuros.website.redesign.styles.RdIncludedStyle
import com.anjuros.website.redesign.styles.RdIncludedTextStyle
import com.anjuros.website.redesign.styles.RdIncludedTitleStyle
import com.anjuros.website.redesign.util.RdText
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.B
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.Ul

/** One item in the included band; with a [path], its title links to the page about it. */
class RdIncludedItem(val icon: @Composable () -> Unit, val title: RdText, val text: RdText, val path: String? = null)

/** Pale-blue band listing what's included, with an icon per item. */
@Composable
fun RdIncludedBand(title: RdText, items: List<RdIncludedItem>, headingId: String = "inc-h") {
    RdSection(labelledBy = headingId, modifier = RdIncludedStyle.toModifier(), wrapModifier = RdIncludedGridStyle.toModifier()) {
        H2(RdIncludedTitleStyle.toModifier().id(headingId).toAttrs()) { Text(LocalText(title)) }
        Ul(RdIncludedListStyle.toModifier().toAttrs()) {
            items.forEach { item ->
                Li {
                    Span(RdIconCircleStyle.toModifier().toAttrs()) { item.icon() }
                    Span(RdIncludedTextStyle.toModifier().toAttrs()) {
                        B {
                            val path = item.path
                            if (path != null) RdLink(path, RdInlineLinkStyle.toModifier()) { Text(LocalText(item.title)) } else Text(LocalText(item.title))
                        }
                        Text(LocalText(item.text))
                    }
                }
            }
        }
    }
}
